.root {
  --field-x-padding: 1rem;
  min-width: 240px;
  height: var(--form-item-base-height);
  /* Uneven values to make the optical centering better */
  padding: 2px var(--field-x-padding) 1px var(--field-x-padding);
  text-overflow: ellipsis;
  font-size: var(--font-size-base);
  font-weight: var(--font-weight-light);
  color: var(--field-color);
  text-indent: 1px;
  letter-spacing: var(--font-small-letter-spacing);
  white-space: nowrap;
  appearance: none;
  background-color: var(--field-background);
  border: 1px solid var(--field-border-color);
  border-radius: 4px;

  &::placeholder {
    color: var(--field-placeholder-color);
  }

  &:focus,
  &:focus-within,
  &:active {
    outline: none;
    border-color: var(--field-border-color-active);
  }

  &[aria-disabled="true"] {
    color: var(--field-color-disabled);
    cursor: not-allowed;
    background: var(--field-background-disabled);
  }

  &:invalid,
  &[aria-invalid="true"] {
    border-color: var(--field-border-color-error);
  }

  &[readonly] {
    color: var(--field-color-readonly);
    cursor: not-allowed;
    background: var(--field-background-readonly);
    border: 1px solid var(--field-border-color-readonly);
  }

  &[type="time"]::-webkit-calendar-picker-indicator {
    background: none;
  }
}

.control {
  position: relative;
  display: inline-block;
  width: min-content;
}

.textarea {
  position: relative;
  display: inline-block;
  width: 100%;

  textarea {
    box-sizing: border-box;
    width: 100%;
    min-height: 200px;
    /* Give the TextArea the same padding top/bottom as X. It looks a little cramped otherwise */
    padding-top: var(--field-x-padding);
    padding-bottom: var(--field-x-padding);
    overflow-wrap: break-word;
    white-space: break-spaces;
    resize: none;
  }
}

.block,
.block input,
.block select {
  width: 100%;
}

.adornedStart {
  padding-left: var(--form-item-base-height);
}

.adornedEnd {
  padding-right: var(--form-item-base-height);
}
